import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";

import { FieldElementBlock } from "../../blocks/shared/components/FieldElementBlock";

interface ShortAnswerBlockMeta {
  elementableId: number;
  elementId: number;
  fieldIndex: number;
  position: number;
  profileFieldId?: number | null;
}
export interface FormShortAnswerBlockProps extends ComponentPropsWithRef<"div"> {
  blockInstanceMeta?: ShortAnswerBlockMeta;
  hidden?: boolean;
  label?: string;
  placeholder?: string;
  required?: boolean;
}

export const FormShortAnswerBlock = forwardRef<
  HTMLDivElement,
  FormShortAnswerBlockProps
>(
  (
    {
      label = "Short answer",
      placeholder = "",
      required = false,
      hidden = false,
      blockInstanceMeta = {},
      ...rest
    },
    ref,
  ) => (
    <FieldElementBlock
      ref={ref}
      blockInstanceMeta={blockInstanceMeta}
      fieldType="short_answer"
      hidden={hidden}
      label={label}
      placeholder={placeholder}
      required={required}
      {...rest}
    />
  ),
);

FormShortAnswerBlock.displayName = "FormShortAnswerBlock";
